<template>
  <b-row>
    <b-col cols="12">
      <b-card v-for="advanceInvoice in advanceInvoices">
        <b-row>
          <b-col cols="8">
            <h4>{{ 'advance_invoice' | translate('global') }}: {{ advanceInvoice.number }}</h4>
          </b-col>
        </b-row>
        <blockquote class="card-blockquote mt-2 col-12">
          <div class="table-responsive">
            <table class="table table-sm center">
              <thead>
              <tr>
                <th class="no-border-top">{{ 'supplier' | translate('global') }}</th>
                <th class="no-border-top">{{ 'invoice_issue_at' | translate('global') }}</th>
                <th class="no-border-top">{{ 'order_payment_term' | translate('global') }}</th>
                <th class="no-border-top">{{ 'status' | translate('global')}}</th>
                <th class="no-border-top">{{ 'structure' | translate('global')}}</th>
                <th class="no-border-top">{{ 'sum' | translate('global') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="border-r-3">{{ advanceInvoice.supplier }}</td>
                <td class="border-r-3">{{ advanceInvoice.issueAt }}</td>
                <td class="border-r-3">{{ advanceInvoice.paymentTerms }}</td>
                <td class="border-r-3">{{ advanceInvoice.status }}</td>
                <td class="border-r-3">{{ advanceInvoice.structure }}</td>
                <td class="border-r-3">{{ advanceInvoice.sum }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </blockquote>
        <b-card-footer>
          <b-row>
            <b-col cols="12" md="12">
              <div class="pull-right">
                <AdvanceInvoiceApprove :id="advanceInvoice.id"
                                       :isDisabled="!advanceInvoice.approveInvoiceReview"/>
                <AdvanceInvoiceSendToBookkeeper :id="advanceInvoice.id"
                                                :isDisabled="!advanceInvoice.openForPaymentApprove"/>
                <AdvanceInvoiceDecline :id="advanceInvoice.id"
                                       :isVisible="advanceInvoice.declineInvoiceReview"/>
                <b-button variant="danger" v-if="advanceInvoice.removeInvoice" class="ml-4" @click="onRemove(advanceInvoice.id)">
                  <b-spinner v-if="spinners.isRemoving" type="grow" small/>
                  <i class="fa fa-minus mr-2"/>{{ 'advance_invoice_remove' | translate('global') }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import {mapActions} from 'vuex';
  import forEach from 'lodash.foreach';
  import VuexTypes from '@/store/types/index';
  import AdvanceInvoiceApprove from './AdvanceInvoiceApprove';
  import AdvanceInvoiceSendToBookkeeper from './AdvanceInvoiceSendToBookkeeper';
  import AdvanceInvoiceDecline from './AdvanceInvoiceDecline';

  const OrdersTypes = VuexTypes.orders;

  export default {
    props: {
      data: {
        type: Array
      }
    },
    components: { AdvanceInvoiceApprove, AdvanceInvoiceSendToBookkeeper, AdvanceInvoiceDecline },
    data() {
      return {
        spinners: {
          isRemoving: false
        },
        advanceInvoices: []
      }
    },
    watch: {
      data: {
        immediate: true,
        handler: function () {
          this.fillInvoiceData();
        },
        deep: true
      }
    },
    methods: {
      ...mapActions('Orders', [
        OrdersTypes.ORDER_INVOICES_ADVANCE_LIST,
        OrdersTypes.ORDER_REMOVE_INVOICE_ADVANCE,
      ]),
      fillInvoiceData() {
        const result = [];

        forEach(this.data, (advanceInvoice) => {
          result.push({
            id: advanceInvoice['id'],
            number: advanceInvoice['number'] || '-',
            supplier: advanceInvoice['supplier'] ? advanceInvoice['supplier']['name'] : '-',
            issueAt: advanceInvoice['issue_at'] || '-',
            paymentTerms: advanceInvoice['paymentTermsClassifier'] ? advanceInvoice['paymentTermsClassifier']['name']
              : '-',
            status: this.$t(advanceInvoice.status, 'statuses'),
            structure: advanceInvoice['structure'] ? advanceInvoice['structure']['name'] : '-',
            sum: advanceInvoice['sum'] || '-',
            openForPaymentApprove: advanceInvoice['actions']['open_invoice_for_payment_approve'],
            declineInvoiceReview: advanceInvoice['actions']['decline_invoice_review'],
            approveInvoiceReview: advanceInvoice['actions']['approve_invoice_review'],
            removeInvoice: advanceInvoice['actions']['remove_advance_invoice']
          });
        });

        this.advanceInvoices = result;
      },
      onRemove(advanceInvoiceId) {
        this.spinners.isRemoving = true;
        this.ORDER_REMOVE_INVOICE_ADVANCE({
          orderId: this.$route.params.id,
          advanceInvoiceId: advanceInvoiceId
        });
      }
    }
  }
</script>

<style scoped>
</style>
